import { render, staticRenderFns } from "./Permision.vue?vue&type=template&id=0b7de954"
import script from "./Permision.vue?vue&type=script&lang=js"
export * from "./Permision.vue?vue&type=script&lang=js"
import style0 from "./Permision.vue?vue&type=style&index=0&id=0b7de954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports